<style lang="scss">
  // Import custom SASS variable overrides, or alternatively
  // define your variable overrides here instead
  @import './styles/custom-vars.scss';
  @import "./styles/style.scss";

  // Import Bootstrap and BootstrapVue source SCSS files
  @import '~bootstrap/scss/bootstrap.scss';
  @import '~bootstrap-vue/src/index.scss';

  @import "~font-awesome/scss/font-awesome.scss";

</style>

<script>
import { mapGetters } from 'vuex'
import loader from '@/components/shared/loader/loader.vue'
import LightboxLoader from './components/shared/loader/lightbox-loader'

export default {
  name: 'App',
  components: { LightboxLoader, loader },
  computed: {
    ...mapGetters(['loaderOn', 'lightBoxloaderOn'])
  },
  created () {
    this.$store.commit('updateIsSRCCheckoutDisabled', true)
    this.$store.commit('checkoutProgress', false)
  }
}

</script>
<template>
  <div id="app">
    <loader v-if="loaderOn" />
    <lightbox-loader v-if="lightBoxloaderOn" />
    <transition
      mode="out-in"
      name="component-fade"
    >
      <router-view />
    </transition>
  </div>
</template>
